import { Component, OnInit } from '@angular/core';
import { CheckAuth } from 'src/Services/utility.service';
import { ToastrService } from 'ngx-toastr';
import { Title } from '@angular/platform-browser';
import { ManageCrraMasterService } from 'src/Services/manage-crra-master.service';
import { ManageCRRAModel } from 'src/Models/ManageCRRAModel';
import { Router } from '@angular/router';
import { SessionStorageService } from 'src/common/session-storage.service';

@Component({
  selector: 'app-manage-crra',
  templateUrl: './manage-crra.component.html',
  styleUrls: ['./manage-crra.component.css']
})
export class ManageCrraComponent implements OnInit {

  ckeConfig:any;
  tokenKey: string = '';
  objManageCRRAModel = new ManageCRRAModel();
  loginuserID: number;
  description = '';

  constructor(private readonly titleService: Title, 
    private readonly toastr: ToastrService, 
    private readonly manageCrraMaster: ManageCrraMasterService,
    private readonly checkAuth: CheckAuth,
    private readonly router: Router,    private sessionStorageService: SessionStorageService
  ) {
    this.tokenExpireCalculation(this.sessionStorageService.getAppStartTime(),this.sessionStorageService.getTokenExpiryValue());
    this.tokenKey = this.sessionStorageService.getTokenValue();
    this.loginuserID = this.sessionStorageService.getAdminUserId();
    this.titleService.setTitle('Manage CRRA');
  }

  ngOnInit() {

    this.ckeConfig = {
      versionCheck:false,
      toolbar: [
        { items:
          [
          'Undo','Redo','Link','Unlink','Anchor',
          'Image','Table','SpecialChar','Maximize','Source','Bold','Italic','Underline','Strike','RemoveFormat',
          'NumberedList','BulletedList','Outdent','Indent','Styles','Format','Font'
          ]
        }],
    }

    this.GetManageCRRADetails();
  }

  GetManageCRRADetails() {
    this.manageCrraMaster.GetManageCRRADetails(this.tokenKey).subscribe(data => {
      if (data['status'] !== 'Failure') {
        this.objManageCRRAModel = data.result;
      }
    });

  }

  saveManageCRRADetails() {

    if (!this.objManageCRRAModel.title) {
      this.showMessage('Please enter title.', 'Required', 'error');
      return;
    }
    if (!this.objManageCRRAModel.description) {
      this.showMessage('Please enter description.', 'Required', 'error');
      return;
    }
    else {
      this.objManageCRRAModel.userid = this.loginuserID;
      this.manageCrraMaster.SaveManageCRRADetails(this.tokenKey, this.objManageCRRAModel).subscribe(data => {
        if (data['status'] !== 'Failure') {
          this.showMessage('Details Saved Successfully.', 'Success', 'success');
        }
        else {
          this.showMessage('Issue In Saving Your Details.', 'Error', 'error');
        }
      });
    }
  }

  showMessage(msg: string, msgTitle: string, msgType: string) {
    if (msgType == 'success') {
      setTimeout(() => this.toastr.success(msg, msgTitle));
    }
    else if (msgType == 'error') {
      setTimeout(() => this.toastr.error(msg, msgTitle));
    }
  }

  tokenExpireCalculation(startDate: string, tokenExpiry: string) {
    this.checkAuth.tokenExpireCalculation(startDate, tokenExpiry);
  }

  Cancel(){
    let navigation = '/admin/crra/dashboard';
    this.router.navigate([navigation]);
  }
}
